package meineglasfaser.frontend.www.components.layouts

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.navigation.Anchor
import io.ktor.http.*
import meineglasfaser.frontend.www.components.CustomerStateRedirectIfLoggedOut
import meineglasfaser.frontend.www.components.sections.PortalFooter
import meineglasfaser.frontend.www.components.sections.PortalHeader
import org.jetbrains.compose.web.dom.*

@Layout
@Composable
fun PortalLayout(ctx: PageContext, content: @Composable () -> Unit) {
    CustomerStateRedirectIfLoggedOut()

    PortalHeader()
    Main(attrs = { classes(CONTAINER_CLASS, "customer-portal") }) {
        Div({ classes("row-fluid") }) {
            Div({ classes("col-12", "col-md-4", "col-lg-3", "col-xl-2") }) {
                PortalSidebar()
            }
            Div({ classes("col-12", "col-md-8", "col-lg-7", "offset-lg-4", "col-xl-6", "offset-xl-4") }) {
                content()
            }
        }
    }
    PortalFooter()
}

@Composable
private fun PortalSidebar() {
    Aside {
        Nav {
            Ul {
                MenuEntry(
                    displayName = "Übersicht",
                    href = "/kundenportal/overview",
                )
                MenuEntry(
                    displayName = "Bestellungen",
                    href = "/kundenportal/orders",
                )
                MenuEntry(
                    displayName = "Meine Daten",
                    href = "/kundenportal/my-data",
                )
                MenuEntry(
                    displayName = "Login und Sicherheit",
                    href = "/kundenportal/my-account",
                )
            }
        }
    }
}

@Composable
private fun MenuEntry(
    displayName: String,
    href: String,
) {
    val ctx = rememberPageContext()
    val segmentedCurrent = remember(ctx.route.path) {
        Url(ctx.route.path).segments
    }
    val segmentedTarget = remember(href) {
        Url(href).segments
    }
    val level = (segmentedTarget.size - 1).coerceAtLeast(1)
    Li(attrs = {
        classes("entry")
        attr("data-level", level.toString())
    }) {
        Anchor(
            href = href,
            attrs = {
                if (segmentedCurrent == segmentedTarget) {
                    classes("primary")
                } else {
                    classes("text-pill")
                }
            },
        ) {
            Text(displayName)
        }
    }
}
